import { Box, Typography } from '@mui/material';
import styles from 'pages/page-404/Page404.module.css'

const NotFoundPage = () => {
  return (
    <Box className={styles.notFoundBox}>
        <h2><span>404</span> Такая страница не найдена</h2>
    </Box>
  );
};

export default NotFoundPage;
